export default (props, vars) => () =>
  vars?.['usestatecurrentform']?.['setState'](
    vars?.['useapplicationoffer2']?.['applicationOffer'].OFFER_LETTER_FORMS
      .DECLINE
  );
